import classNames from 'classnames';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetLabel } from 'services/labels';
import { ISettlementInfoContractForm } from 'services/music-product-digital/types/form';
import './ProductContractCard.scss';

interface IProductContractCardProps {
  contract: ISettlementInfoContractForm;
}

const ProductContractCard = ({ contract }: IProductContractCardProps) => {
  const { t } = useTranslation();
  const label = useGetLabel(false);
  const isOwnerContract = useMemo(
    () => !!label.data && label.data?.id === contract.labelId,
    [contract.labelId, label.data?.id]
  );

  const className = classNames(['product-contract-card'], { isOwnerContract });

  return (
    <div
      className={className}
      onClick={() =>
        isOwnerContract &&
        window.open(`/contracts/${contract.contractId}`, '_blank')
      }>
      <div className='product-contract-name'>
        <div className='product-contract-header'>
          <p>{`${contract.labelName} ${
            isOwnerContract ? `(${t('me')})` : ''
          }`}</p>
          <p>{contract.divisionPercentage} %</p>
        </div>
        <div className='product-contract-footer'>
          <p>{contract.contractName}</p>
          <p>{contract.startDate}</p>
        </div>
      </div>
    </div>
  );
};

export default ProductContractCard;
